import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom validator to check if a value is 0.
 * If the value is 0, it returns a 'notZero' error.
 */
export const notZeroValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;

  // Check if the value is zero (number or string)
  if (value === 0 || value === '0') {
    return { notZero: true };
  }

  // If the validation passes, return null.
  return null;
};
